import { useCallback } from "react";
import { addDoc, Timestamp } from "firebase/firestore";
import { useFirestoreCollection } from "./useFirestoreCollection";
import { useFirestore } from "./useFirestore.web";

export const useCrackMarks = (
  projectId: string,
  objectId: string,
  crackId: string
) => {
  const [tenantId, , , collection] = useFirestore();

  const collectionPath = [
    "projects",
    projectId,
    "objects",
    objectId,
    "cracks",
    crackId,
    "crackMarks",
  ].join("/");

  const [crackMarks, isLoading] = useFirestoreCollection(collectionPath);

  const addCrackMark = useCallback(
    async (x: number, y: number, size: number) => {
      return addDoc(collection(collectionPath), {
        x,
        y,
        size,
        createdAt: Timestamp.now(),
      });
    },
    [tenantId]
  );

  return { crackMarks, isLoading, addCrackMark };
};
